var $35175b1ad320fcc1$exports = {};
$35175b1ad320fcc1$exports = {
  "alert": "\u012Esp\u0117jimas",
  "dismiss": "Atmesti"
};
export { $35175b1ad320fcc1$exports as default };